<template>
  <v-app>
    <v-content class="pa-5">
     <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
export default {};
</script>
